import {
  LIST_COLORS,
  LIST_COLORS_BUTTON,
  LIST_COLORS_BUTTON_VACANCIES,
  LIST_COLORS_TEXT,
} from '../constants';
import type { TColor } from './types';

export const getContrastBackgroundColor = (color: string) => {
  return findContrastColor(color, LIST_COLORS);
};

export const getContrastButtonColor = (color: string) => {
  return findContrastColor(color, LIST_COLORS_BUTTON);
};

export const getContrastListVacanciesColor = (color: string) => {
  return findContrastColor(color, LIST_COLORS_BUTTON_VACANCIES);
};

export const getContrastTextColor = (color: string) => {
  return findContrastColor(color, LIST_COLORS_TEXT);
};

const findContrastColor = (color: string, colors: TColor[]) => {
  return colors.find(c => c.primaryColor === color)?.secondaryColor;
};
